<template>
  <el-select v-model="selected">
    <option>Select...</option>
    <option v-for="(product, idx) in products" :key="`product-${idx}`" :value="product.id"
      :selected="selected == product.id">{{ product.title }}</option>
  </el-select>
</template>
<script>
import ElSelect from './ElSelect'
export default {
  name: 'ShopifySelect',
  components: {
    ElSelect
  },
  computed: {
    selected: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  },
  props: ['value'],
  data() {
    return {
      products: []
    }
  },
  mounted() {
    this.$CMS_GET('products.index').then((data) => {
      this.products = data.products
    })
  }
}
</script>
